import { useQuery } from "@tanstack/react-query";
import API from "../../api/API";
import { TenantInfo } from "../../../types/TenantInterfaces";

const useClouds = () => {
  const clouds = useQuery<TenantInfo[]>({
    queryKey: ["clouds"],
    queryFn: () =>
      API.getAllUserCloudTenants().then((data) => data.data.data.tenants),
  });

  return {
    clouds: clouds.data,
    cloudsLoading: clouds.isLoading,
    cloudsError: clouds.isError,
  };
};

export default useClouds;
